import { useState } from "react"

import { Icon } from "semantic-ui-react"

import css from './daily-report-collapsible.module.css'

export function DailyReportCollapsible({ title, children, defaultOpen = false }: { title: any, children: any, defaultOpen?: boolean }) {

    const [open, setOpen] = useState<boolean>(defaultOpen)

    return <div className={css.collapsible}>
        <div className={css.header} onClick={() => setOpen(!open)}>
            <Icon name={open ? 'chevron up' : 'chevron down'} />
            <span className="text-bold">{title}</span>
        </div>

        {open && <div className={css.content}>{children}</div>}
    </div>
}
